import React from "react";
import { Link } from "react-router-dom";

export const DefaultInboundLink = ({ to, children, ...rest }) => {
  return (
    <React.Fragment>
      {!!to && (
        <Link to={to} {...rest}>
          {children}
        </Link>
      )}
      {!to && <React.Fragment>{children}</React.Fragment>}
    </React.Fragment>
  );
};
export const DefaultOutboundLink = ({
  to,
  children,
  color = "black",
  ...rest
}) => {
  return (
    <React.Fragment>
      {!!to && (
        <a
          href={to}
          target="_blank"
          rel="noreferrer"
          style={{
            color: color,
            ...rest,
          }}
        >
          {children}
        </a>
      )}
      {!to && <React.Fragment>{children}</React.Fragment>}
    </React.Fragment>
  );
};
